export const selectedGatheringIds = (selectedRows) => {
    if (!Array.isArray(selectedRows)) return [];

    return [
        ...new Set(
            selectedRows
                .map((row) => Number(row?.id))
                .filter((id) => Number.isSafeInteger(id) && id > 0),
        ),
    ];
};

export const deleteSelectedGatherings = async ({
    selectedRows,
    confirmDelete,
    requestDelete,
}) => {
    const gatheringIds = selectedGatheringIds(selectedRows);
    if (gatheringIds.length === 0) return { status: 'empty' };
    if (!confirmDelete()) return { status: 'cancelled' };

    const response = await requestDelete(gatheringIds);
    if (response?.data?.ok !== true) {
        throw new Error(response?.data?.message || '모임 삭제에 실패했습니다.');
    }

    return {
        status: 'deleted',
        gatheringIds,
        message: response.data.message,
    };
};
